import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { InvoicesService } from '../../services/invoices.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { DisputeStorageService } from '../../services/create-dispute-storage.service';
interface IItems {
  itemCAAmountInTransactionCurrency: string
  itemCADocumentNumber: string
  itemCAMainTransactionName: string
  itemNo: string
  itemQuantity: string
  itemTransactionCurrency: string
  itemType: string
  itemTypeName: string
  itemUnitOfMeasureName: string
  taxAmountInTransCurrency: string
  checked: boolean
}

interface MyMap {
  string: Array<IItems>;
}

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class InvoiceDetailsComponent implements OnInit {

  @ViewChild('disputeStatus') disputeStatus: any;

  invoiceId: any;
  invoice: any;
  item: any;
  items: Array<IItems> = new Array<IItems>();
  myMap!: MyMap;
  selectedInvoices: any;
  pendingAmountToPay: number = 0;
  totalEditedAmount: number = 0;
  currency: any;
  showSummary: boolean = false;
  disputeItem: boolean = true;
  top: any = 50;
  skip: any = 0;
  keys: String[] = [];
  invoiceItemData: any;
  sellectedChargeType: any = "All";
  totalCharges: any;
  invoiceDetailsRecieved = false;
  disputeMeassage: String = "You do not have permission to create dispute. Please connect with your system administrator";

  isDisputeCreateEnabled: boolean = environment.DisputeCreateEnableFlag;
  permissions: String[] = environment.billingProps.permissions;

  constructor(
    private invoicesService: InvoicesService,
    private router: Router,
    private modalService: NgbModal,
    private disputeStorageService: DisputeStorageService
  ) {
    this.invoice = history.state.invoice;
    this.getInvoiceDetails(this.invoice);
  }

  ngOnInit(): void { }

  getInvoiceDetails(invoice: any) {
    this.invoiceDetailsRecieved = false;
    this.invoicesService.getInvoiceDetail(invoice.invoice_id, invoice.bpNo, invoice.caContract, true, this.top, this.skip).subscribe((res: any) => {
      this.myMap = res;
      this.invoiceDetailsRecieved = true;
      this.invoiceItemData = Object(this.myMap);
      this.invoiceItemData = this.filterDataBasedOnLength(this.invoiceItemData);
      this.totalCharges = this.getTotalCharges(this.invoiceItemData);
      this.totalCharges = Object(this.totalCharges);
    });
  }

  getTotalCharges(data: any) {
    let sum = 0;
    let costData: any = {};
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value) && value.length > 0) {
        sum = 0;
        for (let val of value) {
          sum = sum + parseFloat(val.itemCAAmountInTransactionCurrency);
        }
        costData[key] = sum;
      }
    }
    sum = 0;
    Object.keys(costData).forEach(function (key) {
      sum = sum + parseFloat(costData[key]);
    });

    costData["Total"] = sum;
    return costData;
  }

  filterDataBasedOnLength(data: any) {
    const filteredData: any = {};
    for (const [key, value] of Object.entries(data)) {
      if (Array.isArray(value) && value.length > 0) {
        filteredData[key] = value;
      }
    }
    return filteredData;
  }

  selectedItem(item: any) {
    this.item = item;
    this.items.forEach((ele) => {
      if (ele.itemNo != item.itemNo) {
        ele.checked = false;
      }
    })
    if (!item.checked || !item.checked) {
      item.checked = true;
    } else {
      item.checked = false;
      this.item = null;
    }
  }

  summary(invoice: any) {
    if (invoice != null) {
      this.selectedInvoices = [];
      this.currency = invoice.currency;
      this.pendingAmountToPay = invoice.pending_amount;
      this.selectedInvoices.push(invoice);
    }
    if (this.pendingAmountToPay == 0) {
      return;
    }
    this.totalEditedAmount = this.pendingAmountToPay;
    this.showSummary = true;
    return;
  }

  selectedCharge(key: any) {
    this.sellectedChargeType = key;
    console.log(key);
  }

  onDisputeInvoiceClick(): void {
    this.disputeStorageService.resetStore();
    // if (this.isDisputeCreateEnabled && this.permissions.includes('BI-CBT')) {
    //   if (this.item && this.item.checked) {
    //     this.router.navigate(['/invoices/dispute'], { state: { invoice: this.invoice, item: this.item, type: 'item' } });
    //   } else {
    //     this.router.navigate(['/invoices/dispute'], { state: { invoice: this.invoice, type: 'invoice' } });
    //   }
    // } else {
    //   this.openModal();
    // }

    if (this.isDisputeCreateEnabled && this.permissions.includes('BI-CBT')) {
      localStorage.setItem('dispute-type', 'invoice-level-dispute')
      localStorage.setItem('selected-invoice-to-dispute', JSON.stringify(this.invoice))
      if (this.item && this.item.checked) {
        localStorage.setItem('selected-type-to-dispute', 'item')
        localStorage.setItem('selected-item-to-dispute', JSON.stringify(this.item))
        this.router.navigate(['/invoices/create-dispute'], { state: { invoice: this.invoice, item: this.item, type: 'item' } });
      } else {
        localStorage.setItem('selected-type-to-dispute', 'invoice')
        this.router.navigate(['/invoices/create-dispute'], { state: { invoice: this.invoice, type: 'invoice' } });
      }
    } else {
      this.openModal();
    }
  }

  openModal(): void {
    this.modalService.open(this.disputeStatus);
  }

  downloadCSV() {
    let jsonData = this.invoiceItemData;
    let csvContent = "";
    function formatHeader(header: any) {
        return header.replace(/([a-z])([A-Z])/g, '$1 $2')
                     .replace(/_/g, ' ')
                     .replace(/\b\w/g, (char: any) => char.toUpperCase());
    }

    Object.keys(jsonData).forEach(category => {
        if (jsonData[category].length === 0)
          return;

        csvContent += `\n${category}\n`;
        const items = jsonData[category];
        const headers = Object.keys(items[0]);
        const formattedHeaders = headers.map(formatHeader);
        csvContent += formattedHeaders.join(",") + "\n";
        
        items.forEach((item: any) => {
            const row = headers.map(header => item[header]);
            csvContent += row.join(",") + "\n";
        });
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${this.invoice.invoice_id}-charges.csv`;
    link.click();
  }
}
